import {createStyles, Theme} from "@material-ui/core";

export const StackedNotificationsStyle = (theme: Theme) =>
    createStyles({
        container: {
            transform: 'translate(-50%, 0%)',
            bottom: '16px',
            right: 'unset',
            left: '50%',
            zIndex: 1100,
            ['@media (max-width:600px)']: { // eslint-disable-line no-useless-computed-key
                zIndex: 2000,
            },
        },
        innerContainer: {
            display: 'flex',
            flexDirection: 'column',

        },
        snackbar: {
            marginTop: '8px',
            position: 'relative',
            width: '100%',
            maxWidth: '500px',
            bottom: 0,
            flexDirection: 'row',
            flexWrap: 'nowrap',
        },
    });



// WEBPACK FOOTER //
// ./src/components/economy/StackedNotifications.style.ts